export interface FirebaseWebConfig {
  ApiKey: string;
  AuthDomain: string;
  ProjectId: string;
  StorageBucket: string;
  MessagingSenderId: string;
  AppId: string;
  MeasurementId?: string;
  VapidKey?: string;
}

export interface ContactList {
  AndroidUrl?: string;
  IosUrl?: string;
  Email?: string;
  Phone?: string;
  Address?: string;
  PrivacyHtml?: string;
  ContactHtml?: string;
  [key: string]: unknown;
}

export interface SocialLinks {
  Facebook?: string;
  Messenger?: string;
  Telegram?: string;
  [key: string]: unknown;
}

export interface Branding {
  Title?: string;
  LogoUrl?: string;
  PrimaryColor?: string;
}

export interface FeatureFlags {
  [key: string]: boolean | string | number | undefined;
}

export interface SubscriptionListConfig {
  CheckoutCurrency?: string;
  DailyUsdRate?: number;
  LockedFeatures?: string[];
  MonthlyKPayAmount?: string;
}

export interface PageConfig {
  PageId: number;
  Title: string;
  LatestAppVersion: number;
  ThumbnailUrl?: string;
  Branding: Branding;
  ContactList: ContactList;
  SocialLinks: SocialLinks;
  FeatureList: FeatureFlags;
  SubscriptionList: SubscriptionListConfig;
  FirebaseList: { Web?: FirebaseWebConfig };
}

export const DefaultPageConfig: PageConfig = {
  PageId: 710,
  Title: 'Crypto Signals',
  LatestAppVersion: 1,
  Branding: {},
  ContactList: {},
  SocialLinks: {},
  FeatureList: {},
  SubscriptionList: {},
  FirebaseList: {},
};

/** Merge partial/cached rows so boot never crashes on missing nested keys. */
export function normalizePageConfig(
  config: Partial<PageConfig> | null | undefined,
): PageConfig {
  const base = config ?? {};
  return {
    ...DefaultPageConfig,
    ...base,
    Branding: { ...DefaultPageConfig.Branding, ...base.Branding },
    ContactList: { ...DefaultPageConfig.ContactList, ...base.ContactList },
    SocialLinks: { ...DefaultPageConfig.SocialLinks, ...base.SocialLinks },
    FeatureList: { ...DefaultPageConfig.FeatureList, ...base.FeatureList },
    SubscriptionList: { ...DefaultPageConfig.SubscriptionList, ...base.SubscriptionList },
    FirebaseList: {
      ...DefaultPageConfig.FirebaseList,
      ...base.FirebaseList,
      Web: base.FirebaseList?.Web ?? DefaultPageConfig.FirebaseList.Web,
    },
  };
}
